import React from "react";
import BlogCard from "./BlogCard";

const BlogList = ({ blogs }) => (
  <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3" data-testid="blog-list">
    {blogs.map((blog) => <BlogCard key={blog.id} blog={blog} />)}
  </div>
);

export default BlogList;
